import React, {useState} from 'react'
import {Button} from 'antd'
import {DownOutlined, RightOutlined} from '@ant-design/icons'
import {useIntl} from 'react-intl'
import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import * as Icons from '@fortawesome/free-solid-svg-icons'

export type PanelProps = {
  title: string
  children: React.ReactNode
  backgroundIcon?: Icons.IconDefinition
}

export function Panel(props: PanelProps) {
  const [modeCollapsed, setModeCollapsed] = useState(false)

  const intl = useIntl()

  return (
    <div className="panel">
      <div className="panel__title">
        <a
          onClick={() => setModeCollapsed((current) => !current)}
          className="panel__title__collapser"
        >
          <div>{intl.formatMessage({id: props.title})}</div>
          <div className="panel__title__collapser__icon">
            {modeCollapsed ? <RightOutlined /> : <DownOutlined />}
          </div>
        </a>
      </div>

      {!modeCollapsed && (
        <div className="panel__body">
          {props.backgroundIcon && (
            <div className="panel__body__background">
              <Icon className="panel__body__background__icon" icon={props.backgroundIcon} />
            </div>
          )}
          {props.children}
        </div>
      )}
    </div>
  )
}
